angular.module('lf.common')

.factory('gtmService', function ($http) {

  var requestGAPropertiesURL = lf.data.xhr.productDetail;
  var device = lf.data.xhr.client;
  /**
   * Map LF product attributes to GTM properties
   * Put GTM properties in quotes is the Google recommendation
   *
   * @param params
   * @returns {{product: {*}}
   */
  var mapGTMParams = function (params) {
    var result = {
      'product': {
        'prodRepName': params.gaProdRepname || params.reportingTitle || params.title, //'data-ga-prod-repname',
        'prodId': params.gaProdId || params.id, //'data-ga-prod-id',
        'sku': params.gaVariant || params.skuId, //'data-ga-variant',
        'skuRepName': params.gaVariantRepname || params.skuReportingTitle, //'data-ga-variant-repname',
        'quantity': 1,
        'skuFormat': params.gaProdSkuformat || params.skuFormat, // ${item.auxiliaryData.catalogRef.format.id} ???
        'skuType': params.gaProdSkutypes || params.skuType, // ${item.auxiliaryData.catalogRef.type}
        'productList': params.gaLocation, // closest data-ga-location value
        'secondaryLoc': params.gaSecondaryLoc, //closest secondary location
        'productPos': params.gaResultposition || params.resPosition || 1 // data-ga-resultposition
      }
    };
    
    if (!angular.isUndefined(params.oldQty)) {
      result.product.oldQty = params.oldQty;
      result.product.newQty = params.newQty;
    }

    return result;
  };

  var pushDataOnRequest = function (gaData, product, extraEvent) {
    $http.get(requestGAPropertiesURL + '?id=' +product.id + '&skuId=' + product.skuId)
      .success(function(data){
        data = jQuery.extend(data, product);
        gaData = jQuery.extend(gaData, mapGTMParams(data));

        dataLayer.push(gaData);
        if (extraEvent) {
          gaData = jQuery.extend({}, gaData, {'event': extraEvent});
          dataLayer.push(gaData);
        }
      })
      .error(function () {
        gaData = jQuery.extend(gaData, mapGTMParams(product));

        dataLayer.push(gaData);
        if (extraEvent) {
          gaData = jQuery.extend({}, gaData, {'event': extraEvent});
          dataLayer.push(gaData);
        }
      });
  }

  var gtmService = {
    
    track: function (params) {
      if (window.dataLayer) {
        dataLayer.push(params);
      }
    },
    
    subscription: {
      login: {
        
        trackSuccessfulLogin: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Creation',
            'lbl': 'Login Button Success'
          }, params);
          gtmService.track(data);
        },
        
        trackUnsuccessfulLogin: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Creation',
            'lbl': 'Login Button Fail'
          }, params);
          gtmService.track(data);
        },
        
        trackForgotPasswordLinkClick: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Creation',
            'lbl': 'Forgot Password'
          }, params);
          gtmService.track(data);
        }
        
      },
      
      payment: {
        
        trackSuccessfulFormSubmission: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Creation',
            'lbl': 'Start Free Trial Success'
          }, params);
          gtmService.track(data);
        },
        
        trackUnsuccessfulFormSubmission: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Creation',
            'lbl': 'Start Free Trial Fail'
          }, params);
          gtmService.track(data);
        }
      },
      
      membership: {
        
        trackUpdatePaymentMethodLinkClick: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Management ',
            'lbl': 'Update Payment Info'
          }, params);
          gtmService.track(data);
        },
        
        trackCancelMembershipLinkClick: function (params) {
          var data = $.extend({
            'event': 'gaEvent',
            'cat': 'Subscription Beta',
            'act': 'Account Management ',
            'lbl': 'Cancel Membership'
          }, params);
          gtmService.track(data);
        }
        
      }
    },

    getParams: function (el, attrs) {
       var gaParams = {};

      if(!attrs) {
        attrs = el.data();
      }

      for (var attrName in attrs) {
        if (attrName.slice(0, 2) === 'ga') {
          gaParams[attrName] = attrs[attrName];
        }
      }

      this.getClosestLocation(el, gaParams);

      return gaParams;
    },

    getClosestLocation: function (el, params) {
      var $locationEl = el.closest('[data-ga-location]');
      params['gaLocation'] = ($locationEl.length) ? ($locationEl.attr('data-ga-location')).toLowerCase().replace(/\s/gi, '') : null;

      //get second location
      $locationEl = el.closest('[data-ga-l2]');
      params['gaSecondaryLoc'] = ($locationEl.length) ? ($locationEl.attr('data-ga-l2')).toLowerCase().replace(/\s/gi, '') : null;
    },

    pushAddToCart: function (params, product) {
      var gaData = {'event': 'mAddToCart'};

      if(params && typeof params === 'object') {
        jQuery.extend(product, params);
      }

      pushDataOnRequest(gaData, product);
    },

    pushRemoveFromCart: function (params, product) {
      var gaData = {'event': 'mRemoveFromCart'};

      if(params && typeof params === 'object') {
        jQuery.extend(product, params);
      }

      pushDataOnRequest(gaData, product);
    },
    
    pushChangeCartQuantity: function (params, product) {
      var gaData = {'event': 'mQtyChange'};

      if(params && typeof params === 'object') {
        jQuery.extend(product, params);
      }

      pushDataOnRequest(gaData, product);
    },

    pushAddToCartFromWishlist: function (product) {
      var gaData = {'event': 'mAddToCartFromWishlist'};

      pushDataOnRequest(gaData, product);
    },

    pushAddToWishlistFromCart: function (product) {
      var gaData = {'event': 'mAddToWishlistFromCart'};

      pushDataOnRequest(gaData, product);
    },

    pushAddToWishlist: function (product) {
      var gaData = {'event': 'mAddToWishlist'};

      pushDataOnRequest(gaData, product);
    },

    pushRemoveFromWishlist: function (product) {
      var gaData = {'event': 'mRemoveFromWishlist'};

      pushDataOnRequest(gaData, product);
    },

    pushSlideInActivity: function (params) {
      dataLayer.push({
        'event': 'mSlidein',
        'slideinName': params.name, //name or id of slidein
        'slideinUrl': params.url || null //slidein url if applicable
      });
    },

    pushVideoActivity: function (params) {
      dataLayer.push({
        'event': 'gaEvent',
        'cat': 'Video',
        'act': params.action, //allowed actions - “Play, “Pause”, “Rewind”
        'lbl': params.url,
        'relatedProduct': params.prodId //'data-ga-prod-id',
      });
    },
    
    pushShowReviews: function (params) {
      dataLayer.push({
        event: 'gaEvent',
        cat: 'Product',
        act: 'Show reviews',
        lbl: params.reportingTitle,
        relatedProduct: params.productId
      });
    },

    pushScreenshotsCarousel: function (params) {
      dataLayer.push({
        'event': 'mScreenshot',
        'scrshtIndex': params.index, // number in the carousel
        'scrshtSrc': params.sourceURL, // image source
        'scrshtAction': params.action //if possible arrow or slide. If possible direction example forward arrow or forward slide
      });
    },

    pushProductsCarousel: function (params) {
      dataLayer.push({
        'event': 'mProdCarousel',
        'prodCarIndex': params.index, //number in the carousel
        'relatedProduct': params.prodId, //data-ga-prod-id - product ID of the product shown
        'prodCarAction': params.action //if possible arrow or slide. If possible direction example forward arrow or forward slide
      });
    },

    pushFormError: function (formName, message) {
      if(typeof message !== 'string') {
        var preparedMesages = [];
        _.each(message, function (val) {
          if(typeof val === 'object') {
            preparedMesages.push(val['message']);
          } else {
            preparedMesages.push(val);
          }
        });

        message = preparedMesages;
      }

      dataLayer.push({
        'event': 'mFormError',
        'formName': formName,
        'message': message
      });
    },

    pushStarterSuccess: function (product, categoryName, deviceGrade, selectedGrade) {
      var prodParams = mapGTMParams(product);
      prodParams = prodParams['product'];
      delete prodParams['productList'];
      delete prodParams['productPos'];
      delete prodParams['quantity'];

      var gtmData = { 'event': 'mStarterSuccess',
                      'starterSuccess': {
                        'deviceType': device.type,
                        'deviceGrade': deviceGrade,
                        'category': categoryName,
                        'selectedGrade': selectedGrade.text,
                        'product': prodParams
                      }
                    };

      dataLayer.push(gtmData);
    },

    pushImpression: function (products, gaLocation) {
      var gtmData = {'event': 'mImpression', 'impressionProducts': []};

      for(var i=0; i<products.length; i++) {
        var product = products[i];

        gtmData['impressionProducts'].push({
          'prodRepName': product.reportingTitle,
          'prodId': product.id,
          'productList': gaLocation,
          'productPos': i+1
        });
      }

      dataLayer.push(gtmData);
    },

    pushRedeemStart: function (codeType, code4LD) {
      dataLayer.push({
        'event':'mRedeemStart',
        'redeemCodeStart': {
          'codeType': codeType,
          'code4LD': code4LD
        }
      });
    },

    pushRedeemSuccess: function (codeType, code4LD, codeValue, product) {
      var gtmData = {
        'event': 'mRedeemSuccess',
        'redeemCodeSuccess': {
          'codeType': codeType,
          'code4LD': code4LD,
          'codeValue': codeValue
        }
      };

      if (product) {
        $.extend(gtmData['redeemCodeSuccess'], {
          'sku': product.skuId,
          'prodId': product.id,
          'prodRepName': product.reportingTitle
        });
      }

      dataLayer.push(gtmData);
    }
  }
  
  return gtmService;
});
